import { render, staticRenderFns } from "./DirectEditInput.vue?vue&type=template&id=2380b52d&scoped=true"
import script from "./DirectEditInput.vue?vue&type=script&lang=js"
export * from "./DirectEditInput.vue?vue&type=script&lang=js"
import style0 from "./DirectEditInput.vue?vue&type=style&index=0&id=2380b52d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2380b52d",
  null
  
)

export default component.exports